
export default {
  // serverURI: 'http://dashboard-coe.test-leakbot.net/v1.0/', // coe env
  // serverURI: 'https://dashboard.testing-leakbot.net/v1.0/', // test env
  serverURI: 'http://127.0.0.1:3000/v1.0/', // local dev env
  // serverURI: 'https://dashboard2.uat-leakbot.net/v1.0/', // uat env
  // serverURI: 'https://dashboard2.leakbot.io/v1.0/', // production
  environment: 'Prod',
  fixedLayout: false,
  hideLogoOnMobile: false
}
